import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const UserColumns: TableColumn[] = [
    {
        name: "fullName", 
        displayName: "Name", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "email", 
        displayName: "Email", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "employeeRole", 
        displayName: "Role", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "birthDate", 
        displayName: "Birth Date", 
        dataType: COLUMN_TYPES.date, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },    
    {
        name: "salaryType", 
        displayName: "Salary Type", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "isActive", 
        displayName: "Active?", 
        dataType: COLUMN_TYPES.bool, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "createdBy", 
        displayName: "Created By", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {width: '30%'},
        reference: '',
        selectOptions: null
    }
];


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.user.ts